/** @format */

export const getStoredAuthToken = () => localStorage.getItem('token');

export const storeAuthToken = (token) => localStorage.setItem('token', token);

export const hasStoredAuthToken = () =>
	localStorage.getItem('token') ? true : false;

export const removeStoredAuthToken = () => localStorage.removeItem('token');
